<template>
  <form @submit.prevent="validatePromoCode">
    <p v-if="!hidePromoCode && !isOpen && !orderError && !currentPromotionCode.code">
      <button class="button-link" @click.prevent="open">Add Promo Code</button>
    </p>
    <div v-if="(isOpen || orderError) && !currentPromotionCode.code" class="promo-code">
      <label class="label" for="promo-code">Promo Code</label>
      <!-- <div class="promo-code__current" v-if="typeof currentPromotionCode.code !== 'undefined' && !orderError">
        <p>Promo code <span class="highlight">{{currentPromotionCode.displayCode}}</span> applied.</p>
        <p>New price with discount will be <strong>{{totalCost | currency}}</strong>.</p>
        <p><a @click.prevent="removePromoCode" href="javascript:void(0)">Remove</a></p>
      </div> -->
      <div class="form__row">
        <div class="form__column input-container" :class="currentPromotionCode.loading ? 'input-container--loading' : ''">
          <input class="input" id="promo-code" name="promo-code" type="text" ref="input" v-model="form.promotionCode">
        </div>
        <input type="submit" class="form__column button" @click.prevent="validatePromoCode" :disabled="form.promotionCode.length === 0 || currentPromotionCode.loading" value="Apply" />
      </div>
      <p class="form__error" v-if="currentPromotionCode.message" v-html="currentPromotionCode.message" />
      <p class="form__error" v-if="orderError">
        {{orderError}}
      </p>
    </div>
  </form>
</template>
<script>
export default {
  data() {
    const { displayCode, code } = this.$store.state.promotionCode;
    return {
      isOpen: typeof displayCode !== 'undefined',
      form: {
        promotionCode: displayCode || code || '',
      },
    };
  },
  computed: {
    orderErrorMessages() {
      return {
        PromoCodeMissing: 'The promotion code is not valid.',
        PromoCodeExpired: 'The promotion code is valid, but has expired.',
        PromoCodeInvalidEmailDomain: 'The promotion code is not supported for the user’s email domain.',
        PromoCodeUseLimitReached: 'The promotion code’s use limit is exceeded.',
        PromoCodeNotValidDate: 'The promotion code is not valid now. It may not have startd yet.',
        RegistrationPromoCodeInvalid: 'The promotion code must be valid for the program and subscription type.',
        InvalidCode: 'Promotion code cannot be found.',
        InvalidUse: 'Promotion code is not valid for use.',
        ErrorRetrievingCode: 'Internal error has prevented this code from being validated.',
      };
    },
    orderError() {
      const { order } = this.$store.state;
      if (order.errorList) {
        const error = order.errorList.find(key => key in this.orderErrorMessages);
        return this.orderErrorMessages[error];
      }
      return null;
    },
    user() {
      return this.$store.state.user;
    },
    registration() {
      return this.$store.state.registration;
    },
    passType() {
      return this.$store.getters.passType;
    },
    totalCost() {
      return this.$store.getters.totalCost;
    },
    currentPromotionCode() {
      return this.$store.state.promotionCode;
    },
    hidePromoCode() {
      return this.passType.discountVerificationType === 'passcode';
    },
  },
  methods: {
    open() {
      this.isOpen = true;

      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    async validatePromoCode() {
      this.$store.dispatch('validatePromotionCode', { promotionCode: this.form.promotionCode });
    },
    removePromoCode() {
      this.$store.dispatch('updatePromotionCode', { promotionCode: {} });
    },
  },
  beforeDestroy() {
    // remove any error messages so they wont be displayed next time the promo code box is entered
    if (!this.currentPromotionCode.code) {
      this.removePromoCode();
    }
  },
};
</script>
